// extracted by mini-css-extract-plugin
module.exports = {"container":"DotLoading_container__xsgT5","dotflashing":"DotLoading_dotflashing__b_vb6"};